import PartnerNormalizationReviewWorkspace from "../../components/partner/inventory/PartnerNormalizationReviewWorkspace";

export default function PartnerInventoryNormalizationReviewPage() {
  return <PartnerNormalizationReviewWorkspace />;
}
